import React from 'react'
import {
  SettingsMenuButton,
  SettingsMenuButtonProps,
} from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button'
import { twMerge } from 'tailwind-merge'
import { SettingsMenuItem, SettingsMenuItemProps } from './settings-menu-item'

export interface SettingsMenuButtonWithIconProps
  extends SettingsMenuButtonProps,
    Pick<SettingsMenuItemProps, 'title' | 'subtitle' | 'skipTranslation'> {
  iconBefore: () => React.ReactNode
  endElement?: () => React.ReactNode
}

export const SettingsMenuButtonWithIcon = ({
  className,
  title,
  subtitle,
  skipTranslation,
  iconBefore,
  onClick,
  endElement,
  icon,
  ...props
}: SettingsMenuButtonWithIconProps) => {
  return (
    <SettingsMenuButton
      className={twMerge('px-0 py-0', className)}
      onClick={onClick}
      icon={icon ?? (() => null)}
      {...props}
    >
      <SettingsMenuItem
        title={title}
        subtitle={subtitle}
        icon={iconBefore}
        skipTranslation={skipTranslation}
      />
      {endElement?.()}
    </SettingsMenuButton>
  )
}
